export enum Project {
  BUY_SKODA = "projet d'achat de véhicule ŠKODA",
  BUY_NOT_SKODA = "projet d'achat de véhicule d'une autre marque",
  KNOW_PRICE = 'connaître le prix de mon véhicule'
}
